import { ContentWidth } from '@ta-interaktiv/react-disco-grid'
import MunicipalitySearch from '@ta-interaktiv/react-municipality-search'
import { ChartFrame } from 'components/ChartFrame'
import Histogram from 'components/Histogram'
import ZoomableImage from 'components/ZoomableImage/ZoomableImage'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

const neibs = require('../../Content/municipalities_neigbours_all.json')
const muni_data_de = require('./20230101_de_nozip.json')
const muni_data_fr = require('./20230101_fr_nozip.json')

const Municipalities = ({
  startGde,
  tenantGde,
  labels,
  colorMode,
  lang = 'de',
}: {
  startGde: number | undefined
  tenantGde: number
  labels: any
  colorMode: 'light' | 'dark' | undefined
  lang: 'de' | 'fr'
}) => {
  const [currentGDE, setCurrentGDE] = useState<any>(startGde)

  const muni_data = lang === 'de' ? muni_data_de : muni_data_fr

  const [currentGDEDATA, setCurrentGDEDATA] = useState<any>()

  useEffect(() => {
    var gde = muni_data.find((f: any) => f.GDENR === startGde)
    if (!gde) {
      gde = muni_data.find((f: any) => f.GDENR === tenantGde)
      setCurrentGDE(tenantGde)
    }
    setCurrentGDEDATA(gde)
  }, [startGde])

  function onMunicipalitySelected(municipality: any) {
    setCurrentGDE(municipality.GDENR)
    setCurrentGDEDATA(municipality)
  }
  function handleCloseMunis(gdenr: number) {
    let found = muni_data.find((f: any) => f.GDENR === gdenr)
    if (found) {
      setCurrentGDE(found.GDENR)
      setCurrentGDEDATA(found)
    }
  }

  return (
    <>
      <ContentWidth>
        <MunicipalitiesContainer>
          <TitleContaner>
            <ChartFrame lang='de' />

            <SearchContainer>
              <MunicipalitySearch
                iconOnRightSide
                customMunicipalities={
                  muni_data.sort(
                    (a: any, b: any) =>
                      a.NORMGEMEINDE.length - b.NORMGEMEINDE.length
                  ) as any
                }
                locale={'de'}
                dedupe
                maxResults={8}
                onCloseHandler={() => {
                  setCurrentGDEDATA(null)
                  setCurrentGDE(null)
                }}
                resetOnSelect
                placeholder={labels.search_muni}
                onSelectionHandler={onMunicipalitySelected}
              />
            </SearchContainer>
          </TitleContaner>
          {!currentGDE && (
            <NoGdeSelected>
              <div>{labels.no_muni_selected}</div>
            </NoGdeSelected>
          )}
          {currentGDE && currentGDEDATA && (
            <>
              <MapContainer>
                <GdeInfo>{currentGDEDATA.NORMGEMEINDE}</GdeInfo>

                <NeibMunis>
                  <b>{labels.neib_muni}:</b>
                  {currentGDE && neibs[currentGDE] && (
                    <>
                      {neibs[currentGDE].allneibs.map((m: any, i:number) => {
                        return (
                          <button
                            onClick={() => handleCloseMunis(m[1])}
                            key={'neib_' + i}
                          >
                            {m[0]}
                          </button>
                        )
                      })}
                    </>
                  )}
                </NeibMunis>

                <ZoomableImage
                  lang={lang}
                  gde={currentGDE}
                  colorMode={colorMode}
                  labels={labels}
                />
              </MapContainer>
              <HistogramContainer>
                <TextCol>
                  <p>{labels.histo_info}</p>
                  {currentGDEDATA && (
                    <Histogram
                      lang={lang}
                      colorMode={colorMode}
                      labels={labels}
                      gdeData={currentGDEDATA}
                    />
                  )}
                  {labels.histo_text}
                </TextCol>
              </HistogramContainer>
            </>
          )}
        </MunicipalitiesContainer>
      </ContentWidth>
    </>
  )
}

const TitleContaner = styled.div`
  max-width: 668px;
  margin-left: auto;
  margin: auto;
  text-align: center;
`
const NoGdeSelected = styled.div`
  margin-top: 60px;
  margin-bottom: 60px;
  div {
    border: 1px solid var(--gray-3);
    display: inline-block;
    margin-bottom: 60px;
    padding: 30px;
    border-radius: 4px;
  }
`
const GdeInfo = styled.div`
  width: 100%;
  text-align: left;
  font-size: 30px;
  font-weight: 700;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  margin-top: 6%;
  text-align: center;
  max-width: 668px;
`
const NeibMunis = styled.div`
  margin-top: 10px;

  margin-bottom: 30px;
  font-size: 13px;
  display: flex;
  flex-wrap: wrap;
  text-align: left;
  font-size: 13px;
  opacity: 0.5;
  margin-left: auto;
  margin-right: auto;
  b {
    font-weight: 300;
    display: inline-block;
    width: 100%;
  }
  max-width: 400px;
  max-width: 668px;
  text-align: center;
  button {
    color: var(---text-color);
    box-sizing: border-box;
    border: 0;
    display: inline-block;
    background-color: transparent;
    letter-spacing: 0.35px;
    padding: 0;
    line-height: 1em;
    margin-bottom: 10px;
    padding: 10px 0;
    margin-right: 10px;
    border-bottom: 1px solid var(--text-color);
    padding-bottom: 3px;
    padding-top: 2px;

    @media screen and (max-width: 711px) {
      margin-bottom: 4px;
      font-size: 12px;
    }

    &:hover {
      font-weight: 700;
      cursor: pointer;
    }
  }
  justify-content: center;
  @media screen and (max-width: 711px) {
    margin-left: 15px;
    margin-right: 15px;
  }
`
const MunicipalitiesContainer = styled.div`
  margin-bottom: 60px;
  background: rgb(248, 248, 248);
  background: var(--muni-gradient);
  text-align: center;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 60px;
  padding-bottom: 60px;
  @media screen and (max-width: 711px) {
    max-width: calc(100% - 80px);
    margin-left: auto;
    margin-right: auto;
    padding-top: 30px;
  }
  .municipality-search {
    text-align: left;
    z-index: 420;
    margin: 0;
    width: 100%;

    .results {
      width: 100%;
      max-width: unset;
      background-color: var(--gray-4);
    }
    .result {
      border-bottom: 1px solid var(--gray-3);
      color: var(--brandblue-main);
    }
    input {
      justify-content: flex-end;
      align-items: flex-end;
      #search-closing-icon {
        padding: 20px !important;
        justify-self: flex-end;
      }
      max-width: unset;
      font-size: 18px;
      padding-left: 15px;
      @media screen and (max-width: 711px) {
        font-size: 16px;
        padding: 15px;
      }
    }
  }
`

const SearchContainer = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  z-index: 420;
`
const HistogramContainer = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 30px;
`

const TextCol = styled.div`
  font-family: var(--font-serif);
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-bottom: 40px;

  @media screen and (max-width: 711px) {
    max-width: calc(100% + 40px);
    width: calc(100% + 40px);
    margin-left: -20px;
  }
`

const MapContainer = styled.div`
  overflow: hidden;
  max-width: 900px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 60px;
  position: relative;
  img {
    max-width: 100%;
    margin-top: 15px;
    @media screen and (max-width: 711px) {
      max-width: calc(100% + 40px);
      width: calc(100% + 40px);
      margin-left: -20px;
    }
  }
  @media screen and (max-width: 711px) {
    margin-bottom: 30px;
    @media screen and (max-width: 711px) {
      width: calc(100% + 40px);
      margin-left: -20px;
    }
  }
`

export default Municipalities
